<template>
  <b-modal
      id="update-share-assessment"
      :title="_.get(shareRecord, 'sassessment.id') + ' shared with ' + _.get(shareRecord, 'sgroup.groupName')"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
    >
    <template #modal-header-close>
      <h4>X</h4>
    </template>
    <b-row>
      <b-col>
        <br>
        <b>Created At: </b> {{ getCreatedAt() }}
        <br>
        <b>Last Updated: </b> {{ getLastUpdateDate() }}
        <br>
        <b>Current Status: </b> {{ _.get(shareRecord, 'assessmentShareStatus', false) ? 'Shared' : 'Not Shared' }}
        <br>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100"></div>
  </b-modal>
</template>

<script>
export default {
  name: 'update-share-assessment-modal',
  props: {
    assessmentId: Number,
    assessmentOrganizationOwner: Number,
    shareRecord: Object,
    showModal: Boolean
  },
  computed: {
    isShared: function () {
      return _.get(this.shareRecord, 'assessmentShareStatus', false)
    }
  },
  maethods: {
    getCreatedAt () {
      const shareRecord = this.shareRecord
      if (shareRecord.createdAt && shareRecord.createdAt.includes('T')) {
        return this.$utils.formatDate(shareRecord.createdAt)
      } else if (shareRecord.createdAt) {
        return this.$utils.unixToHuman(shareRecord.createdAt / 1000)
      }
    },
    getLastUpdateDate: function () {
      const shareRecord = this.shareRecord
      if (shareRecord.updatedAt && shareRecord.updatedAt.includes('T')) {
        return this.$utils.formatDate(shareRecord.updatedAt)
      } else if (shareRecord.updatedAt) {
        return this.$utils.unixToHuman(shareRecord.updatedAt / 1000)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Share/UpdateShareAssessmentModal.vue